// extracted by mini-css-extract-plugin
export default {"paymentLinkContainer":"PaypalLink_paymentLinkContainer__qopKL","paymentLinkLabel":"PaypalLink_paymentLinkLabel__4CicF"};